import React from 'react'
import type { ComponentTypes } from 'types/selectComponent'
import type { FilterComponentNode, FilterComponentRendererType, FilterGenericPropsType } from '../type'
import CableThicknessFilter, { FilterOptionsType } from './CableThicknessFilter'

export const CABLE_THICKNESS_FILTER_KEY = 'cable_thickness'

const maybeCreateCableThicknessFilterNode = ({
  componentType,
  RendererComponent,
}: {
  componentType?: ComponentTypes
  RendererComponent: FilterComponentRendererType<FilterOptionsType>
}): FilterComponentNode | undefined => {
  if (componentType !== 'other') {
    return
  }

  const FilterComponent = (props: FilterGenericPropsType) => (
    <CableThicknessFilter filterKey={CABLE_THICKNESS_FILTER_KEY} RendererComponent={RendererComponent} {...props} />
  )

  return {
    key: CABLE_THICKNESS_FILTER_KEY,
    component: FilterComponent,
  }
}

export default maybeCreateCableThicknessFilterNode
